import { atom, selector } from 'recoil'
import { Trainer } from '../../../../api/generated'
import { ManagementApi } from '../../../../api/generated/Api'
import { GetApiConfig, GetAuthUser } from '../../../auth/services/authService'

export const TrainersAsyncAtom = atom<Trainer[]>({
  key: 'trainers',
  default: selector<Trainer[]>({
    key: 'trainers/default',
    get: async ({ get }) => {
      const authUser = GetAuthUser()
      if (authUser === null) return []

      const apiConfig = GetApiConfig()
      const response = await new ManagementApi(apiConfig).apiManagementTrainersGet()
      return response.data
    },
  }),
})
